import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { InputProps, Option } from './types';
import { useStyles as useSharedStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomData } from '../../Reducers/Configurator/Actions';
import { setProductParamsValid } from '../../Reducers/App/Actions';
import { getCustomData } from '../../Reducers/App/Selectors';
import { darkBlue, red, white } from '../../Constants/Colors';

const useStyles = makeStyles(() => ({
  autocomplete: {
    '& .MuiInputBase-root': {
      backgroundColor: white,
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline':
      {
        borderColor: `${red} !important`,
      },
    '& .MuiAutocomplete-popupIndicator': {
      color: darkBlue,
    },
  },
}));

const CWAutocompleteField: React.FC<InputProps> = (props) => {
  const { field } = props;
  const classes = useStyles();
  const sharedClasses = useSharedStyles();
  const dispatch = useDispatch();

  const storedValue = useSelector((state) => getCustomData(state)?.[field.identifier]) || '';
  const selectedOption = field.options?.find((o) => o.value === storedValue) || null;

  useEffect(() => {
    dispatch(
      setProductParamsValid({ [field.identifier]: field.validation?.required ? !!storedValue : true })
    );
  }, []);

  const handleChange = (_e: React.ChangeEvent<unknown>, option: Option | null) => {
    const value = option?.value || '';
    dispatch(setCustomData({ [field.identifier]: value }));
    dispatch(setProductParamsValid({ [field.identifier]: field.validation?.required ? !!value : true }));
  };

  const placeholder = field.placeholderSlug ? t(field.placeholderSlug) : field.placeholder;

  return (
    <Grid container className={sharedClasses.component}>
      <Grid item xs={12}>
        <FormControl className={sharedClasses.formControl}>
          <Autocomplete
            options={field.options || []}
            getOptionLabel={(option: Option) => option.label}
            value={selectedOption}
            onChange={handleChange}
            className={classes.autocomplete}
            renderInput={(params) => <TextField {...params} placeholder={placeholder} variant="outlined" />}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CWAutocompleteField;
